import { useEffect } from 'react';
import { Linking } from 'react-native';

import { track } from '../lib/analytics';
import { ApplyField } from '../lib/apply/applyFields';

interface ApplyBrowserProps {
  visible: boolean;
  onClose: () => void;
  url: string;
  position?: string;
  company?: string;
  fields: ApplyField[];
}

// Web has no usable in-app browser — most job sites block being framed
// (X-Frame-Options / CSP), and the page is already in a browser. So when asked
// to open, we just navigate to the URL in a new tab and dismiss. Renders nothing.
const ApplyBrowser = ({ visible, onClose, url }: ApplyBrowserProps) => {
  useEffect(() => {
    if (!visible) return;
    track('apply_open_external');
    Linking.openURL(url).catch(() => undefined);
    onClose();
  }, [visible, url, onClose]);
  return null;
};

export default ApplyBrowser;
